import { getters } from "./getters";
import { mutations } from "./mutations";

const state = {
  variants: [],
  products: [],
  globals: {},
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
